/**
 * Pull-to-refresh maths (Phase 171) — the DOM-free half of `PullToRefresh`.
 */

/** Pull this far (after easing) to trigger a refresh. */
export const PULL_THRESHOLD_PX = 70;
/** The indicator never travels further than this. */
export const PULL_MAX_PX = 120;
/** Keep the spinner up at least this long, so a fast refetch still reads as one. */
export const MIN_SPINNER_MS = 500;

/**
 * How far the indicator should sit for a raw finger travel of `rawDy`.
 * Eased (the indicator moves slower than the finger) and capped, so a long
 * pull reads as "held at the limit" rather than dragging the page apart.
 */
export function pullDistance(rawDy: number): number {
  if (rawDy <= 0) return 0;
  return Math.min(PULL_MAX_PX, rawDy * 0.55);
}
